import { useMemo, useState } from "react";
import { subscriptionService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IPermission } from "@miplatform/types";
import { createUUID } from "@miplatform/utils";

const getPermissionsListUUID = createUUID();

export const usePermissionsList = () => {
  const stateManager = useComponentState();

  const [permissionsList, setPermissionsList] = useState<IPermission[]>();
  const [recordPermissions, setRecordPermissions] = useState<IPermission[]>();
  const [roleRecordPermissions, setRoleRecordPermissions] =
    useState<IPermission[]>();

  const getPermissionsList = async () => {
    stateManager.abort(getPermissionsListUUID);
    return stateManager.run(async () => {
      const response = await subscriptionService.permissions.getAll();

      if (response.status === HTTP_STATUSES.OK) {
        setPermissionsList(response.data);
      }
      return response;
    }, getPermissionsListUUID);
  };

  const getRecordPermissions = async () => {
    const response = await subscriptionService.recordPermissions.getAll();

    if (response.status === HTTP_STATUSES.OK) {
      setRecordPermissions(response.data);
    }
    return response;
  };

  const getRoleRecordPermissions = async (roleId: string) => {
    const response = await subscriptionService.roleRecordPermissions.getAll({
      id: roleId,
    });

    if (response.status === HTTP_STATUSES.OK) {
      setRoleRecordPermissions(response.data);
    }
    return response;
  };

  const permissionsNamesList = useMemo(
    () => permissionsList?.map((permission) => permission?.name),
    [permissionsList]
  );

  return {
    permissionsList,
    getPermissionsList,
    permissionsNamesList,
    recordPermissions,
    getRecordPermissions,
    getRoleRecordPermissions,
    roleRecordPermissions,
    loading: stateManager.isBusy(),
  };
};
